import { useMantineTheme } from '@mantine/core';
import { ErrorNotification, ErrorNotificationType } from 'components/ErrorNotification/ErrorNotification';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const { colors } = useMantineTheme();
  const [searchParams] = useSearchParams();
  const errorDescription = searchParams.get('error_description');
  return (
    <div
      style={{
        backgroundColor: colors.lime[5],
        height: '100vh',
        width: '100vw',
      }}
    >
      <ErrorNotification type={errorDescription as ErrorNotificationType} />
    </div>
  );
};

export default ErrorPage;
